"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviousMeterReading = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../shared/core");
var utils_1 = require("../utils");
var Icon_styled_1 = require("./Icon.styled");
var MeterReadingForm_styled_1 = require("./MeterReadingForm.styled");
var MeterReadingValidationPrompt_styled_1 = require("./MeterReadingValidationPrompt/MeterReadingValidationPrompt.styled");
var displayReadingValue = function (reading, fuel, timeOfUseLabel, meterNumOfDigits) {
    if (timeOfUseLabel === void 0) { timeOfUseLabel = null; }
    var meterReadingValue = (function () {
        if (fuel === 'electricity' && 'tiers' in reading) {
            var elecTier = reading.tiers.find(function (tier) { return tier.timeOfUseLabel === timeOfUseLabel; });
            return (elecTier === null || elecTier === void 0 ? void 0 : elecTier.meterRegisterReading) || null;
        }
        if ('gasVolume' in reading) {
            return reading.gasVolume;
        }
        return null;
    })();
    if (!meterReadingValue) {
        return null;
    }
    return (0, utils_1.applyLeadingZeros)(meterNumOfDigits, Math.floor(meterReadingValue));
};
var PreviousMeterReading = function (_a) {
    var reading = _a.reading, fuel = _a.fuel, meterNumOfDigits = _a.meterNumOfDigits;
    var Icon = (0, core_1.useComponents)().Icon;
    return (0, utils_1.isReadingsMultirate)(reading) ? (react_1.default.createElement(MeterReadingForm_styled_1.StyledPreviousReadingContainer, null,
        react_1.default.createElement(MeterReadingForm_styled_1.StyledReadingsIconLabel, { "data-testid": "previous-reading-offpeak" },
            react_1.default.createElement(Icon_styled_1.StyledIconWrapper, { inline: true },
                react_1.default.createElement(Icon, { name: "offpeakLegacy" })),
            react_1.default.createElement(MeterReadingForm_styled_1.StyledReadingsText, null,
                react_1.default.createElement(MeterReadingValidationPrompt_styled_1.StyledReading, null, displayReadingValue(reading, fuel, 'offpeak', meterNumOfDigits)))),
        react_1.default.createElement(MeterReadingForm_styled_1.StyledReadingsIconLabel, { "data-testid": "previous-reading-peak" },
            react_1.default.createElement(Icon_styled_1.StyledIconWrapper, { inline: true },
                react_1.default.createElement(Icon, { name: "peakLegacy" })),
            react_1.default.createElement(MeterReadingValidationPrompt_styled_1.StyledReading, null, displayReadingValue(reading, fuel, 'peak', meterNumOfDigits))))) : (react_1.default.createElement("span", { "data-testid": "previous-reading-anytime" },
        react_1.default.createElement(MeterReadingValidationPrompt_styled_1.StyledReading, null, displayReadingValue(reading, fuel, 'anytime', meterNumOfDigits))));
};
exports.PreviousMeterReading = PreviousMeterReading;
